import { cloneStorageToDictionary } from "./helpers";
import { IAnnotation } from "../model/DutyStatusLog";
import { DriveStore } from "../store/reducers";

export const getClonedAnnotationsForUser = (store: DriveStore, userId?: string): IIdDictionary<IAnnotation> => {
    const storageLogs = userId && store.getState().hosAnnotations[userId] || {};
    return cloneStorageToDictionary<IAnnotation>(storageLogs);
};